// Version management for Selfi
// Update this version number before each deployment

export const APP_VERSION = '1.4.0';
export const BUILD_DATE = new Date().toISOString().split('T')[0];

// Version history
export const VERSION_HISTORY = [
  { version: '1.4.0', date: '2025-10-01', changes: 'Production deployment' },
  { version: '1.3.0', date: '2025-09-11', changes: 'Production deployment' },
  { version: '1.2.0', date: '2025-09-11', changes: 'Production deployment' },
  { version: '1.1.1', date: '2025-09-11', changes: 'Added voice preview samples with play buttons for each voice option' },
  { version: '1.1.0', date: '2025-09-11', changes: 'Added Settings page with voice selection, theme, and data management' },
  { version: '1.0.3', date: '2025-09-11', changes: 'Production deployment' },
  { version: '1.0.2', date: '2025-09-11', changes: 'Production deployment' },
  { version: '1.0.1', date: '2025-09-11', changes: 'Added version tracking, fixed OpenAI transcription' },
  { version: '1.0.0', date: '2025-09-11', changes: 'Initial production release' }
];

export function getVersionString() {
  return `v${APP_VERSION}`;
}

export function getFullVersionString() {
  return `Selfi v${APP_VERSION} (${BUILD_DATE})`;
}
